import { MethodType, Context } from '../../utils/types';
import {
  USER_TYPES,
  generalAdabyronBehaviour,
  makeUndefinedValueNull,
} from '../../utils/adaByron';
import { ObjectToTransformValue } from '../../utils/common';

export enum PATHS {
  SEND_TO_SE = 'venta/finalizar/backoffice',
}

/**
 * @typedef {Object} data
 * @property {string} clientFullName client full name
 * @property {string} clientNumberDocument client document number
 * @property {string} contactPhone client contact phone
 * @property {string} contactEmail client contact email
 * @property {string} cqId TELCO CQ id of the purchase
 * @property {Object} message info to send to SE in the message body
 * @property {string} subject subject of the SE message
 *
 * Call DSS COL api backoffice to send to SE.
 * @param {data}
 * @param {Object} context global context
 * @param {string} idFront id to separate GP purchase, TGES os servicing
 */
export const sendToSE = (
  data: {
    clientFullName: string;
    clientNumberDocument: string;
    clientTypeDocument: string;
    contactPhone: string;
    contactEmail: string;
    cqId: string;
    message: ObjectToTransformValue;
    subject: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const {
    clientFullName,
    clientNumberDocument,
    clientTypeDocument,
    contactPhone,
    contactEmail,
    cqId,
    message,
    subject,
  } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.SEND_TO_SE,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.TGES, USER_TYPES.OPEN],
    eventName: 'SE.SEND_TO_SE',
    mockedInfo: 'sendToSE',
    methodType: MethodType.POST,
    requestObject: makeUndefinedValueNull({
      client: {
        fullName: clientFullName,
        numberDocument: clientNumberDocument,
        documentType: clientTypeDocument,
        contactPhone,
        mailContact: contactEmail,
      },
      customerQuoteId: cqId,
      message,
      subject,
    }),
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
    telcoHostVersion: 10,
  });
};

/**
 * Promesa independiente para enviar a SE seguro movil en un
 * flujo manual como segundo envio
 *
 * @typedef {Object} data
 * @property {string} clientFullName client full name
 * @property {string} clientNumberDocument client document number
 * @property {string} contactPhone client contact phone
 * @property {string} contactEmail client contact email
 * @property {string} cqId TELCO CQ id of the purchase
 * @property {Object} message info to send to SE in the message body
 * @property {string} subject subject of the SE message
 *
 * Call DSS COL api backoffice to send to SE.
 * @param {data}
 * @param {Object} context global context
 * @param {string} idFront id to separate GP purchase, TGES os servicing
 */
export const sendToSEMobileInsurance = (
  data: {
    clientFullName: string;
    clientNumberDocument: string;
    clientTypeDocument: string;
    contactPhone: string;
    contactEmail: string;
    cqId: string;
    message: ObjectToTransformValue;
    subject: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const {
    clientFullName,
    clientNumberDocument,
    clientTypeDocument,
    contactPhone,
    contactEmail,
    cqId,
    message,
    subject,
  } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.SEND_TO_SE,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.OPEN],
    eventName: 'SE.SEND_TO_SE_MOBILE_INSURANCE',
    mockedInfo: 'sendToSEMobileInsurance',
    methodType: MethodType.POST,
    requestObject: makeUndefinedValueNull({
      client: {
        fullName: clientFullName,
        numberDocument: clientNumberDocument,
        documentType: clientTypeDocument,
        contactPhone,
        mailContact: contactEmail,
      },
      customerQuoteId: cqId,
      message,
      subject,
    }),
    requestHeaders: { 'Content-Type': 'application/json;charset=UTF-8' },
    telcoHostVersion: 10,
  });
};
